module.exports = __webpack_public_path__ + "img/00051.53dfea39.webp";